import { once } from 'lodash-es';
import { getNewRelicAgent } from 'newRelicAgent';

import { enableScriptForServiceWithConsent } from 'utils/enable-script-for-service-with-consent';
import { loadScript } from 'utils/loadScript';
import { usercentricsEnabled } from 'utils/usercentrics';
import { usercentricsServiceNames } from 'utils/usercentrics-content-change-event-listener';
import { usercentricsServiceStatus } from 'utils/usercentrics-service-status';

const addYammerButton = () => {
  var span = document.createElement('span');
  span.id = 'yj-share-button';
  span.style.display = 'none';
  document.body.appendChild(span);
};

const loadYammerSDK = () => {
  addYammerButton();

  const yammerConfig = {
    id: 'yammer-sdk-js',
    defer: true,
    src: 'https://s0.assets-yammer.com/assets/platform_social_buttons.min.js',
  };

  if (usercentricsEnabled()) {
    yammerConfig.type = 'text/plain';
    yammerConfig.dataset = {
      usercentrics: usercentricsServiceNames.vivaEngage,
    };

    loadScript(yammerConfig);

    enableScriptForServiceWithConsent();

    return usercentricsServiceStatus(usercentricsServiceNames.vivaEngage) ? Promise.resolve() : Promise.reject();
  } else {
    return loadScript(yammerConfig).catch(() => {
      getNewRelicAgent().noticeError(new Error('Viva Engage client cannot be loaded.'));
    });
  }
};

const loadYammerSDKOnce = once(loadYammerSDK);

export { loadYammerSDKOnce };
